













































import Vue from "vue";
import  { mapActions, mapGetters, mapState } from "vuex";
import iwProgressionWizard from "@/encoding/components/progressionWizard/ProgressionWizard.vue";
import iwResetWizardModal from "@/encoding/components/ResetWizardModal.vue";
import { Step } from "@/shared/interfaces/Step.interface";
import { getExtendSteps } from "@/encoding/scripts/steps";
import { WizardState } from "@/shared/interfaces/WizardState.interface";

export default Vue.extend({
    name: "Extend",
    components: {
        iwProgressionWizard: iwProgressionWizard,
        iwResetWizardModal: iwResetWizardModal,
    },

    props: {
        action: {
            type:String,
            required: false,
            default: ""
        }
    },

    data: function() {
        return {
            isMobile: true as boolean,
            mainSidebarSticky: false as boolean,
            classified: null,
            packs: null,
            mainSidebarIsFixed: false as boolean,
        };
    },

    computed: {
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading"
        }),
        ...mapState("StepsWizard", {
            currentStep: state => (state as WizardState).current,
        }),
        validatedSteps: function(): Array<Step> {
            //TODO: Check Here
            return this.$store.getters["FormModule/getValidatedSteps"];
        },
    },

    created: function() {
        this.initWizard({config: getExtendSteps()});
    },

    mounted: function() {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
            this.mainSidebarSticky = true;
        }, () => {
            this.isMobile = true;
            this.mainSidebarSticky = false;
        });
    },

    methods: {
        ...mapActions({
            initValidatedStep: "StepsWizard/validate",
            initWizard: "StepsWizard/init"
        }),
        handleMainSidebarScroll: function() {
            let documentElement = (
                document.scrollingElement ||
                document.documentElement ||
                document.body.parentNode ||
                document.body
            ) as HTMLElement;

            let documentScrollTop = 0;
            if(documentElement) {
                documentScrollTop = documentElement.scrollTop;
            }

            // Top Navigation
            let topNavigation = document.getElementById("main-sidebar");
            if (topNavigation) {
                if (documentScrollTop > 1) {
                    this.mainSidebarIsFixed = true;
                } else {
                    this.mainSidebarIsFixed = false;
                }
            }
        }
    }
});
